import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    width?: number;
    height?: number;
    stroke?: string;
    strokeWidth?: number;
};

export const StopIcon = ({ width = 24, height = 24, stroke = 'currentColor', strokeWidth = 2.4, ...props }: Props) => {
    const { scaleHeightPixel } = useScreenSize();

    return (
        <svg width={scaleHeightPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M20.5 4L12.5 12M12.5 12L4.5 20M12.5 12L4.5 4M12.5 12L20.5 20" stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" />
        </svg>
    );
};
